import { ReactElement, useState } from 'react';
import SideBar from '../../components/SideBar';
import ResetPassword from './ResetPassword';
import { Link } from 'react-router-dom';

import {
  UserDataContent,
  SideBarArea,
  UserDataArea,
  Separator,
  CardOption
} from './styles';
import axios from 'axios';

function getMcLoginConfig() {
  const tokenPatient = `Bearer ${String(
    localStorage.getItem('api_patientToken')
  )}`;
  return {
    headers: {
      authorization: tokenPatient
    }
  };
}

export default function UserSecurity(): ReactElement {
  const [passwordForm, setPasswordForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [erro, setErro] = useState('');
  const [erros, setErros] = useState<string[]>([]);

  const [inputErros, setInputErros] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false
  });

  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  async function changePassword(): Promise<void> {
    setMessage('');
    setErro('');
    setErros([]);

    if (!oldPassword || !newPassword || !confirmPassword) {
      handleMissingFields();
      return;
    }

    if (newPassword !== confirmPassword) {
      setErro('As senhas não conferem');
      setErros([]);
      return;
    }

    await performPasswordReset();
  }

  function handleMissingFields(): void {
    setErro('Preencha os campos em vermelho:');
    setErros([]);
    setInputErros({
      oldPassword: !oldPassword,
      newPassword: !newPassword,
      confirmPassword: !confirmPassword
    });
  }

  async function performPasswordReset(): Promise<void> {
    setLoading(true);

    try {
      const payload = {
        appOrigin: 'predicta-web',
        password: newPassword,
        actualPassword: oldPassword
      };

      const baseUrlLogin = process.env.REACT_APP_MC_LOGIN_URL || '';
      const url = `${baseUrlLogin}/reset-password`;
      const config = getMcLoginConfig();

      const { data } = await axios.put(url, payload, config);

      if (data?.statusCode === 202) {
        setErro('');
        setErros([]);
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setMessage('Senha alterada com sucesso');
      } else {
        console.log(data?.statusCode);
        throw new Error('Senha errada');
      }

      setLoading(false);
    } catch (error: unknown) {
      let message = 'Não foi possível atualizar sua senha';

      const axiosError = error as { response?: { status?: number; statusCode?: number } };
      console.log(axiosError?.response);

      if (axiosError?.response?.status === 403) {
        message = 'Sua senha atual está incorreta';
      }

      setErro(message);
      setErros(['']);
      console.log(
        'UNKNOWN_ERROR_RESET_PASS',
        axiosError?.response?.statusCode || 500
      );
    }

    setLoading(false);
  }
  return (
    <UserDataContent>
      <SideBarArea>
        <SideBar />
      </SideBarArea>
      <UserDataArea>
        <h1>Segurança e Privacidade</h1>
        <Separator />
        <CardOption>
          <div>
            <h2>Senha</h2>
            <p>Altere sua senha de acesso ao Einstein Conecta</p>
          </div>
          <div>
            <button
              onClick={() => setPasswordForm(!passwordForm)}
              className="link"
            >
              {passwordForm ? 'Fechar' : 'Alterar senha'}
            </button>
          </div>
        </CardOption>
        <ResetPassword
          loading={loading}
          show={passwordForm}
          message={message}
          erro={erro}
          erros={erros}
          inputErros={inputErros}
          oldPassword={oldPassword}
          newPassword={newPassword}
          confirmPassword={confirmPassword}
          setOldPassword={setOldPassword}
          setNewPassword={setNewPassword}
          setConfirmPassword={setConfirmPassword}
          changePassword={changePassword}
        />
        <Separator />
        {/* <CardOption>
          <div>
            <h2>Exibir meu prontuário completo - <span className="danger">Inativo</span></h2>
            <p>Exiba todos seus exames e atendimentos do Einstein em seu histórico</p>
          </div>
          <div>
            <Link to="/prontuario" className="link">Editar</Link>
          </div>
        </CardOption>
        <Separator />
        <CardOption>
          <div>
            <h2>Autenticação em dois fatores - <span className="success">Ativo</span></h2>
            <p>Proteja sua conta utilizando seu e-mail ou celular para fazer login</p>
          </div>
          <div>
          <Link to="/autenticacao" className="link">Editar</Link>
          </div>
        </CardOption>
        <Separator /> */}
        <CardOption>
          <div>
            <h2>Upload de documentos</h2>
            <p>
              Faça upload de uma foto de seu documento para validar sua conta
            </p>
          </div>
          <div>
            <Link to="/upload-documentos" className="link">
              Ver mais
            </Link>
          </div>
        </CardOption>
        <Separator />
      </UserDataArea>
    </UserDataContent>
  );
}
